import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initOrg, setOrg, selectOrg, selectUserOrg, ORG_STORAGE_KEY, Org } from '../state/filtersSlice';

export const ORG_TITLES: Record<Org, string> = { SU: 'Style Union', ETH: 'Ethnicity' };

export function readStoredOrg(): string | null {
  try {
    return localStorage.getItem(ORG_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function useOrg() {
  const dispatch = useDispatch();
  const org = useSelector((s: any) => selectOrg(s)) as Org;
  const userOrg = useSelector((s: any) => selectUserOrg(s));
  const canSwitch = userOrg === 'ALL';

  const change = useCallback(
    (next: Org) => {
      if (userOrg !== 'ALL') return;
      dispatch(setOrg(next));
      try {
        localStorage.setItem(ORG_STORAGE_KEY, next);
      } catch {
        /* storage unavailable */
      }
    },
    [dispatch, userOrg],
  );

  return { org, userOrg, canSwitch, title: ORG_TITLES[org], setOrg: change };
}

/** Seeds the org in the store from the logged-in user (mount once, in SuRoutes). */
export function useInitOrg() {
  const dispatch = useDispatch();
  const userOrg = useSelector((s: any) => selectUserOrg(s));
  useEffect(() => {
    dispatch(initOrg({ userOrg, stored: readStoredOrg() }));
  }, [dispatch, userOrg]);
}
